import { formatISO } from 'date-fns'
import { v4 as uuidV4 } from 'uuid'
import { computeDurationFromDates } from '@opallabs/lambda'
import { CreateViewMutationParams } from '../../queries/view'
import { OpalApiResponseDocument } from '../../schema'

type Block = OpalApiResponseDocument<'ReadBlocksBFFV1', 200>['data'][number]

export const createResourceObject = ({
  creator,
  endDate,
  startDate,
  title,
}: Omit<CreateViewMutationParams, 'workspaceUuid'>): Block => ({
  category_type: null,
  id: 'temp-' + uuidV4(),
  created_at: new Date().toISOString(),
  description: null,
  title: title,
  duration: computeDurationFromDates(startDate, endDate),
  start_date: formatISO(startDate),
  last_updated_date: new Date().toISOString(),
  image_id: null,
  is_template: false,
  is_workspace_wide_template: false,
  template_description: null,
  template_name: null,
  effective_privacy: 'some_but_not_all',
  owner: {
    id: creator.uuid,
    full_name: creator.name,
    avatar_url: creator.asset?.url ?? null,
    legacy_id: creator.legacyId,
  },
  child_view_id: null,
  connectors: [],
})
